import { render, staticRenderFns } from "./TabRelationWorkorders.vue?vue&type=template&id=1c00c990"
import script from "./TabRelationWorkorders.vue?vue&type=script&setup=true&lang=js"
export * from "./TabRelationWorkorders.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports